import React from "react";
import { PageHero, FadeUp } from "../../components/public/Section";
import { CheckCircle2 } from "lucide-react";

const OBJECTIVES = [
  "Foster continuing medical education among ophthalmologists at every career stage.",
  "Encourage clinical research and evidence-based practice within the community.",
  "Facilitate collaboration between hospitals, academic institutions and practitioners.",
  "Promote community eye health awareness and preventive care across Ghaziabad and NCR.",
  "Uphold the highest ethical standards in medical practice.",
  "Support mentorship for residents, fellows and young ophthalmologists.",
  "Advocate for policies that improve access to quality eye care.",
  "Recognize excellence in academic, clinical and community service work.",
];

export default function Objectives() {
  return (
    <div>
      <PageHero title="Objectives" subtitle="The pillars that guide the society's activities and initiatives." breadcrumbs={["Home", "About", "Objectives"]} />
      <section className="section container-page">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {OBJECTIVES.map((o, i) => (
            <FadeUp key={i} className="flex gap-4 p-6 rounded-xl bg-white border border-brand-border shadow-card">
              <div className="w-10 h-10 rounded-lg bg-brand-primary-light text-brand-primary flex items-center justify-center shrink-0"><CheckCircle2 size={18} /></div>
              <div className="text-brand-text leading-relaxed">{o}</div>
            </FadeUp>
          ))}
        </div>
      </section>
    </div>
  );
}
